var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 10.0197L23.25 7.8322M10.75 10.0197V24.2385M10.75 10.0197V7.00751C10.75 6.71337 10.8538 6.42864 11.043 6.20344C11.2322 5.97823 11.4948 5.82697 11.7845 5.77626L21.7845 4.02626C22.5494 3.89236 23.25 4.48095 23.25 5.25751V7.8322M23.25 7.8322V21.7385M7.86297 21.775L6.53797 22.0067C5.96716 22.1067 5.44987 22.4047 5.07711 22.8484C4.70435 23.2921 4.5 23.853 4.5 24.4325C4.5 25.9624 5.88016 27.1219 7.38703 26.8581L8.71203 26.6264C9.28284 26.5265 9.80013 26.2285 10.1729 25.7848C10.5457 25.3411 10.75 24.7801 10.75 24.2006C10.75 22.6708 9.36984 21.5113 7.86297 21.775ZM20.363 19.275L19.0381 19.5067C18.4673 19.6066 17.95 19.9046 17.5772 20.3483C17.2044 20.792 17 21.353 17 21.9325C17 23.4624 18.3802 24.6219 19.887 24.3581L21.2119 24.1264C21.7827 24.0265 22.3 23.7285 22.6728 23.2848C23.0456 22.8411 23.25 22.2802 23.25 21.7006C23.25 20.1708 21.8698 19.0113 20.363 19.275Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/appleMusic.c3c44cc473c7c5f7a3e676bb06feb6fc.svg";
export { ForwardRef as ReactComponent };